import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import image1 from "../../../../assets/advisory/prof.png";

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography variant={"subtitle2"} fontWeight={700}>
        Advisor
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "60%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "100%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            Prof Yemi Akegbejo-Samsons
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={{ xs: "50%", sm: "23%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.facebook.com/"
            title="Facebook"
          >
            <Avatar
              sx={{
                bgcolor: blue[900],
                width: 46,
                height: 46,
              }}
            >
              <FacebookIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.twitter.com/"
            title="Twitter"
          >
            <Avatar
              sx={{
                bgcolor: "#000",
                width: 46,
                height: 46,
              }}
            >
              <XIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://linkedin.com/in/yemi-akegbejo-samsons-350ab6146"
            title="LinkedIn"
          >
            <Avatar
              sx={{
                bgcolor: blue[700],
                width: 46,
                height: 46,
              }}
            >
              <LinkedInIcon />
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Grid container marginTop={{ xs: "10%", sm: "2%" }}>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "40vh", sm: "400px" }}
            paddingBottom={{ xs: "7%", sm: "0%" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
        </Grid>
        <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
          >
            Prof Yemi Akegbejo-Samsons is currently a Professor of Aquaculture
            and Coastal Fisheries Management at the Federal University of
            Agriculture, Abeokuta (FUNAAB). Akegbejo-Samsons has worked at
            FUNAAB for over 20 years where he has risen from the position of
            Lecturer ll to his present level. He is a Renewable Natural
            Resources Manager, who has spent over thirty years teaching and
            writing about the essentials of the management of tropical water
            resources.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
            paddingTop={{ xs: "0.5%", sm: "2%" }}
          >
            He is a highly experienced scholar who had worked as a Civil
            servant, Consultant, Teacher and a University Lecturer. He has
            BSc/MSc degrees in Aquaculture and Fisheries Management at the
            University of Ibadan, Nigeria, and a DMA in Marine Affairs from
            Dalhousie University, Halifax, NS Canada. He obtained his PhD in
            Aquaculture and Coastal Resources Management at the Federal
            University of Technology, Akure, Nigeria.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "2%" }}
          paddingTop={{ xs: "0.5%", sm: "0%" }}
        >
          <Typography variant="body1" color={"#4f4f4f"} paragraph>
            Prof Akegbejo-Samsons’ primary research interest is in Aquaculture
            and Fisheries Development cum Coastal Resources Management. He has
            over sixty publications in various areas of Aquaculture, Fisheries
            Management, Aquaculture Nutrition, Pond Water Management and
            Coastal/Wetland Management and Coastal Resources Management. He has
            held many top-level positions in the academia, including Deputy
            Dean, Postgraduate School, Deputy Dean, College of Environmental
            Resources Management, HOD, Aquaculture and Fisheries Management and
            Dean, Student Affairs Division.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "2%" }}
          >
            He is currently the University Representative at the TUNING AFRICA
            PROJECT, a joint Africa, AU/ EU Strategy Tuning program for Higher
            Education and Capacity Development (Agriculture Subject Group) in
            African Universities.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
